import React, { useState } from 'react';
import { BookOpen, MessageCircle, Upload, X } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { mockData } from '../mock';

const products = [
  { id: "polo", name: "Polo T-Shirts", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/7gzz2wkd_images%20%287%29.png",
    catalogImage: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/bbdxcena_WhatsApp%20Image%202026-04-13%20at%207.26.57%20PM.jpeg",
    colors: ["Black","White","Red","Turkish Blue","Royal Blue","Orange","Navy Blue","Maroon","Green","Grey","Yellow","Charcoal","Beige","Pink"],
    colorHexes: ["#000000","#FFFFFF","#DC2626","#0EA5E9","#1E3A8A","#F97316","#1E3A5F","#7F1D1D","#16A34A","#9CA3AF","#EAB308","#374151","#D2B48C","#EC4899"],
    sizes: ["S","M","L","XL","XXL","3XL"], description: "Premium polo t-shirts available in 15 vibrant colors. Perfect for corporate branding." },
  { id: "roundneck", name: "Round Neck T-Shirt", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/6m3cono8_images%20%288%29.png",
    catalogImage: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/o02hpmf2_WhatsApp%20Image%202026-04-14%20at%205.14.00%20PM.jpeg",
    colors: ["Black","White","Sky Blue","Royal Blue","Red","Green","Navy Blue","Purple","Orange","Maroon","Yellow","Charcoal","Grey","Pink"],
    colorHexes: ["#000000","#FFFFFF","#93C5FD","#1E3A8A","#DC2626","#16A34A","#1E3A5F","#6B21A8","#F97316","#5B1A1A","#EAB308","#374151","#9CA3AF","#F9A8D4"],
    sizes: ["S","M","L","XL","XXL","3XL","4XL"], description: "Comfortable round neck t-shirts in 24 colors. Ideal for team uniforms and events." },
  { id: "formal-shirt", name: "Formal Shirts", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/95etj0o7_images%20%285%29.png",
    catalogImage: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/7jwt6twp_WhatsApp%20Image%202026-04-14%20at%204.20.57%20PM.jpeg",
    colors: ["White","Light Blue","Navy Blue","Black","Grey","Pink","Charcoal","Beige","Maroon","Royal Blue","Cream"],
    colorHexes: ["#FFFFFF","#93C5FD","#1E3A5F","#000000","#9CA3AF","#F9A8D4","#374151","#D2B48C","#7F1D1D","#1E3A8A","#FFFDD0"],
    sizes: ["S","M","L","XL","XXL","3XL"], description: "Professional formal shirts for corporate offices. Available in 12 colors with custom embroidery." },
  { id: "cargo", name: "Cargo Pants", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/v4ruely0_cargo-pants-icon-simple-flat-600nw-2601499875.webp",
    catalogImage: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/urtbwal0_WhatsApp%20Image%202026-04-14%20at%203.39.15%20PM.jpeg",
    colors: ["Navy Blue","Khaki","Dark Grey","Black"],
    colorHexes: ["#1E3A5F","#C4A962","#4B5563","#000000"],
    sizes: ["28","30","32","34","36","38","40","42","44"], sizeLabel: "Waist Size", description: "Durable cargo pants for industrial and field work. Available in 4 colors, waist sizes 28-44." },
  { id: "formal-pants", name: "Formal Pants", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/kva3jvha_black-formal-mens-trousers-isolated-260nw-2572158307.webp",
    catalogImage: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/540zldo6_WhatsApp%20Image%202026-04-14%20at%204.46.04%20PM.jpeg",
    colors: ["Black","Navy Blue","Charcoal","Khaki"],
    colorHexes: ["#000000","#1E3A5F","#374151","#C4A962"],
    sizes: ["28","30","32","34","36","38","40","42","44"], sizeLabel: "Waist Size", description: "Classic formal pants for corporate and office wear. 4 colors, waist sizes 28-44." },
  { id: "chef-coat", name: "Chef Coats", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/j3qc75c1_images%20%284%29.png",
    catalogImage: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/lo5e1acx_WhatsApp%20Image%202026-04-14%20at%203.52.57%20PM.jpeg",
    colors: ["White","Black"],
    colorHexes: ["#FFFFFF","#000000"],
    sizes: ["S","M","L","XL","XXL","3XL"], description: "Professional chef coats available with piping and without piping. Custom logo embroidery included." },
  { id: "apron", name: "Aprons", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/8ps1btld_visually-engaging-glyph-icon-of-apron-kitchen-wear-vector.jpg",
    catalogImage: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/m0i1kq8f_WhatsApp%20Image%202026-04-14%20at%205.36.33%20PM.jpeg",
    colors: ["Black","Beige","Charcoal","Chocolate","Navy","Orange","Fuchsia","White","Red","Tan","Khaki"],
    colorHexes: ["#000000","#D2B48C","#374151","#5C3317","#1E3A5F","#F97316","#C026D3","#FFFFFF","#DC2626","#D2B48C","#C4A962"],
    sizes: ["Full Apron","Half Apron"], sizeLabel: "Type", description: "Full and half aprons in 12 colors. Perfect for restaurants, cafes, and catering. Free logo embroidery." },
  { id: "waistcoat", name: "Waistcoat", icon: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/1cx04f10_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2004_29_03%20PM.png",
    colors: ["White","Black"],
    colorHexes: ["#FFFFFF","#000000"],
    sizes: ["S","M","L","XL","XXL","3XL"], description: "Classic waistcoats for hospitality and corporate events. Available in 2 styles with embroidery." },
  { id: "bandana-chef-cap", name: "Bandana Chef Cap", icon: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/ro6hqs50_61rxAoEquvL._AC_UY350_.jpg",
    colors: ["White","Black"],
    colorHexes: ["#FFFFFF","#000000"],
    sizes: ["One Size"], description: "Colorful bandana-style chef caps. Multiple colors available for kitchen staff." },
  { id: "safety-vest", name: "Safety Vest", icon: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/gr7j61r0_images%20%286%29.jpg",
    colors: ["Neon Yellow","Orange"],
    colorHexes: ["#CCFF00","#F97316"],
    sizes: ["S","M","L","XL","XXL","3XL"], description: "High visibility safety vests for industrial and construction environments. Custom logo printing available." },
  { id: "hoodie", name: "Hoodie", icon: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/o3rcj0ss_S76c2e881e03b4e95bdd04e82f4e057ceH.avif",
    colors: ["Black","Navy Blue","Grey","Charcoal","White","Maroon"],
    colorHexes: ["#000000","#1E3A5F","#9CA3AF","#374151","#FFFFFF","#7F1D1D"],
    sizes: ["S","M","L","XL","XXL","3XL"], description: "Premium hoodies for corporate teams and events. Multiple colors available." },
  { id: "cotton-cap", name: "Cotton Caps", icon: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/d3b936qa_61sHJLWcEZL._AC_UY350_.jpg",
    colors: ["Navy","Orange","Rose Red","Yellow","Light Yellow","Dark Grey","Burgundy","Black","Beige","Khaki","Light Orange","Grey","Pink","Coffee","White","Sapphire","Light Green"],
    colorHexes: ["#1E3A5F","#F97316","#E11D74","#EAB308","#D4FF00","#6B7280","#800020","#000000","#F5F0DC","#C4A962","#FF8C00","#9CA3AF","#F9A8D4","#6F4E37","#FFFFFF","#0F52BA","#90EE90"],
    sizes: ["One Size"], description: "Cotton baseball caps in 17 vibrant colors. Perfect for branding, events, and team uniforms." },
];

const CataloguePage = () => {
  const { contact } = mockData;
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'polo';

  const handleInquiry = (productName) => {
    const msg = `Hello! I'm interested in ${productName}.\n\nPlease share pricing, available colors and sizes.`;
    window.location.href = `https://wa.me/${contact.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <section className="py-6" data-testid="catalogue-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <Badge className="bg-blue-900 text-white px-4 py-2 text-sm font-semibold mb-4">
            <BookOpen className="h-4 w-4 mr-2" />
            PRODUCT CATALOGUE
          </Badge>
          <h2 className="text-4xl font-bold text-gray-900 mb-3">Our Products</h2>
          <p className="text-lg text-gray-600">Browse our complete product range and inquire via WhatsApp</p>
        </div>

        <Tabs defaultValue={defaultTab} className="w-full">
          <TabsList className="w-full flex overflow-x-auto pb-2 md:grid md:grid-cols-4 gap-3 md:gap-4 bg-transparent p-0 mb-8 h-auto snap-x">
            {products.map((p) => (
              <TabsTrigger
                key={p.id}
                value={p.id}
                data-testid={`tab-${p.id}`}
                className="flex-shrink-0 flex flex-col items-center gap-1.5 md:gap-2 px-3 md:px-4 py-3 md:py-5 rounded-xl border-2 shadow-sm hover:shadow-md transition-all h-auto border-gray-200 bg-white hover:border-blue-300 data-[state=active]:bg-blue-900 data-[state=active]:text-white data-[state=active]:border-blue-900 data-[state=active]:shadow-lg snap-start min-w-[120px] md:min-w-0"
              >
                <img src={p.icon} alt={p.name} className="h-10 w-10 md:h-16 md:w-16 object-contain" />
                <span className="text-xs md:text-sm font-bold text-center leading-tight">{p.name}</span>
                <span className="text-[10px] md:text-xs font-semibold text-green-500 data-[state=active]:text-green-300 hidden md:block">View Details</span>
              </TabsTrigger>
            ))}
          </TabsList>

          {products.map((product) => (
            <TabsContent key={product.id} value={product.id}>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
                {/* Left: Image */}
                <div className="flex justify-center items-start">
                  <div className="rounded-xl overflow-hidden shadow-md border border-gray-200 bg-white w-full">
                    <img
                      src={product.catalogImage || product.icon}
                      alt={`${product.name} Catalogue`}
                      className="w-full h-auto max-h-[350px] md:max-h-[500px] object-contain"
                    />
                  </div>
                </div>

                {/* Right: Info */}
                <div className="space-y-4 md:space-y-6">
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{product.name}</h3>
                    <p className="text-gray-600 text-base md:text-lg">{product.description}</p>
                  </div>

                  {/* Colors */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Available Colors ({product.colors.length})</label>
                    <div className="flex flex-wrap gap-2">
                      {product.colors.map((color, i) => (
                        <div key={color} className="flex flex-col items-center gap-0.5">
                          <div
                            className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-gray-300 shadow-sm"
                            style={{ backgroundColor: product.colorHexes[i] }}
                            title={color}
                          />
                          <span className="text-[10px] md:text-xs text-gray-500">{color}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Sizes */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">{product.sizeLabel || 'Available Sizes'}</label>
                    <div className="flex flex-wrap gap-1.5 md:gap-2">
                      {product.sizes.map((s) => (
                        <span key={s} className="px-3 md:px-4 py-1.5 md:py-2 rounded-lg border-2 border-gray-200 text-xs md:text-sm font-semibold text-gray-700 bg-gray-50">{s}</span>
                      ))}
                    </div>
                  </div>

                  {/* Features */}
                  <div className="bg-green-50 rounded-xl p-4 border border-green-200">
                    <div className="flex items-center gap-2 text-green-700 font-semibold text-sm">
                      <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                      Ready stock — Same-day delivery available
                    </div>
                  </div>

                  {/* CTA */}
                  <Button
                    onClick={() => handleInquiry(product.name)}
                    data-testid={`${product.id}-inquiry-btn`}
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-6 text-lg font-semibold rounded-xl"
                    size="lg"
                  >
                    <MessageCircle className="mr-2 h-5 w-5" />
                    Inquire via WhatsApp
                  </Button>
                </div>
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default CataloguePage;
